export const HOME = '/';
export const NEW_PASSWORD = '/new-password';
export const VERSION = '/version';
export const FORGOT_PASSWORD = '/forgot-password';

